import React, { useState } from 'react';
import { Button } from 'primereact/button';
import styles from './CateringProviderCard.module.css';
import cateringmgcard from '../../../assets/images/icon 9/Meals Full 2.png';
import { useSelector } from 'react-redux';

const CateringProviderCard = ({ 
  provider, 
  isInCart, 
  onAddToCart, 
  onRemoveFromCart,
  
  onQuantityChange,
  searchQuery = '',
  userSelectedItems = [],
  item,
  matchType = 'other'
}) => {
  console.log("catererprovider", provider, item);
  const [showIncludes, setShowIncludes] = useState(false);

const { commonData } = useSelector(state => state.serviceBooking);
const quantity = commonData.cateringQuantity || 1;
  if (!item) {
    return null;
  }

  const getMaskedAddress = (provider) => {
    const { city, state } = provider;
    if (city && state) {
      return `***, ${city}, ${state}`;
    } else if (city) {
      return `*** ${city}`;
    } else if (state) {
      return `***, ${state}`;
    }
    return 'Location not specified';
  };

  const maskedAddress = getMaskedAddress(provider);

  const calculateItemPrice = () => {
    const regularPrice = parseFloat(item?.regularPrice) || 0;
    const discountedPrice = parseFloat(item?.discountedPrice) || regularPrice;
    const finalPrice = discountedPrice * quantity;
    
    return {
      regularPrice,
      discountedPrice,
      finalPrice,
      displayPrice: `₹${finalPrice} for ${quantity} plates`,
      perPlatePrice: discountedPrice,
      hasDiscount: discountedPrice < regularPrice
    };
  };

  const priceInfo = calculateItemPrice();

  const handleAddToCartClick = () => {
    
    const cartItem = {
      // Provider details
      ...provider,
      
      // Selected item details
      selectedItem: item,
      itemId: item.itemId,
      mealType: item.meal?.name,
      cuisineType: item.type?.name,
      category: item.category?.name,
      price: priceInfo.finalPrice,
      regularPrice: priceInfo.regularPrice,
      discountedPrice: priceInfo.discountedPrice,
      quantity: quantity,
      matchType: matchType,
      
      // Keep all provider items for reference
      allItems: provider.originalData?.items || [],
      
      // Additional metadata
      serviceType: 'catering',
      eventDate: provider.eventDate,
      location: provider.location,
      latitude: provider.latitude,
      longitude: provider.longitude,
      whoseEvent: provider.whoseEvent
    };
    
    console.log("Adding to cart with complete data:", cartItem);
    onAddToCart(cartItem);
  };

  return (
    <div className={`${styles.providerCard} ${styles[`providerCard-${matchType}`]}`}>
      {/* Header Section */}
      <div className={styles.providerHeader}>
        <div className={styles.experienceSection}>
          <span className={styles.expcount}>5+ Years Experience</span>
          <span className={styles.rating}>4.5</span>
        </div>
        <div className={styles.distanceInMeter}>
          <span className="pi pi-map-marker"></span>
          <span>{Number(provider.distanceInMeter / 1000).toFixed(2)} km</span>
        </div>
      </div>

      {/* Body Section */}
      <div className={styles.providerBody}>
        <div className={styles.providerInfo}>
          {/* Provider Name */}
          <h3 className={styles.providerName}>{provider.businessName || provider.name}</h3>
          
          {/* Item Name */}
          {/* <h4 className={styles.itemName}>{item.itemName || 'Menu Item'}</h4> */}
{/*           
          <div className={styles.providerAddress}>
            <span className="pi pi-map-marker"></span>
            <span>{maskedAddress}</span>
          </div> */}
          
          {/* Item Description */}
          {/* {item.description && (
            <div className={styles.itemDescription}>
              {item.description}
            </div>
          )} */}
          
          {/* Price Display */}
          <div className={styles.priceSection}>
            {priceInfo.hasDiscount ? (
              <>
                <span className={styles.originalPrice}>₹{priceInfo.regularPrice * quantity}</span>
                <span className={styles.discountedPrice}>{priceInfo.displayPrice}</span>
                <span className={styles.discountBadge}>
                  Save ₹{(priceInfo.regularPrice - priceInfo.discountedPrice) * quantity}
                </span>
                <div className={styles.perPlate}>₹{priceInfo.perPlatePrice} per plate</div>
              </>
            ) : (
              <>
                <span className={styles.regularPrice}>{priceInfo.displayPrice}</span>
                <div className={styles.perPlate}>₹{priceInfo.perPlatePrice} per plate</div>
              </>
            )}
          </div>

          {/* Show More Button for Included Items */}
          {item.includedItems?.length > 0 && (
            <div className={styles.showMoreSection}>
              <Button
                label={showIncludes ? "Show Less" : "Show more"}
                icon={showIncludes ? "pi pi-chevron-up" : "pi pi-chevron-down"}
                className={styles.showMoreButton}
                onClick={() => setShowIncludes(!showIncludes)}
              />
            </div>
          )}

          {/* Included Items (shown when Show More is clicked) */}
          {showIncludes && item.includedItems?.length > 0 && (
            <div className={styles.includedItemsSection}>
              <strong>Items:</strong>
              <div className={styles.includedItemsList}>
                {item.includedItems.map((includedItem, index) => (
                  <span key={index} className={styles.includedItem}>
                    {includedItem.itemName || includedItem.name}
                    {index < item.includedItems.length - 1 ? ', ' : ''}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className={styles.providerImageContainer}>
          <div className={styles.providerImage}>
            <img 
              src={item.imageUrl || provider.imageUrl || cateringmgcard} 
              alt={item.itemName || 'Menu Item'}
              onError={(e) => {
                e.target.src = cateringmgcard;
              }}
            />
          </div>
          <div className={styles.overlayButton}>
            {isInCart ? (
              <Button
                label="Remove"
                icon="pi pi-times"
                className={styles.removeButton}
                onClick={() => onRemoveFromCart(provider.id)}
              />
            ) : (
              <Button
                label="Add"
                icon="pi pi-plus"
                className={styles.addButton}
                onClick={handleAddToCartClick}
              />
            )}
          </div>
        </div>
      </div>

      {/* Match Badge */}
      {matchType !== 'other' && (
        <div className={`${styles.matchBadge} ${styles[`matchBadge-${matchType}`]}`}>
          {matchType === 'exact' ? '✓ Perfect Match' : 'Similar Match'}
        </div>
      )}
    </div>
  );
};

export default CateringProviderCard;